import { site, stats } from "@/mocks/site";

export default function BrandStory() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-6">
          <p className="text-xs font-medium tracking-widest text-primary-600">BRAND · 品牌介绍</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            我们为什么做蝌蚪爆料
          </h2>
          <div className="mt-5 space-y-4 text-sm leading-[1.9] text-foreground-700">
            <p>
              爆料这件事，最麻烦的从来不是"有没有消息"，而是消息太碎。
              一条线索散在群里，一段画面发在动态里，一句补充出现在评论区，等你想认真了解时，已经找不到完整脉络了。
            </p>
            <p>
              蝌蚪爆料想解决的就是这件事。我们把零散的现场描述、画面记录和讨论整理成一条有先后顺序的线索，
              标注清楚哪些能确认、哪些还只是推测，让你在最短的时间里看懂一件事情的经过。
            </p>
            <p>
              我们不做信息的中转站，只做信息的整理者。每一条内容都会交代线索来源类型，
              能被核实的写成事实，暂时无法核实的保持标注，这是我们对自己最基本的要求。
            </p>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-7 border-t border-background-200 pt-8">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs text-foreground-500">{item.label}</dt>
                <dd className="mt-2 font-heading text-2xl font-bold text-primary-600">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-6">
          <div className="h-64 w-full overflow-hidden rounded-lg md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20desk%20scene%20with%20notebooks%20and%20a%20glowing%20lamp%20on%20a%20cream%20surface%2C%20soft%20amber%20light%2C%20clean%20composed%20composition%2C%20premium%20magazine%20photography%2C%20no%20text&width=900&height=1100&seq=kelou-about-brand&orientation=portrait"
              alt="蝌蚪爆料内容整理工作场景"
              title="蝌蚪爆料内容原则"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="mt-5 rounded-lg border border-background-200 bg-background-100 p-5">
            <p className="font-heading text-base font-semibold text-foreground-950">
              {site.slogan}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{site.mission}</p>
          </div>
        </div>
      </div>
    </section>
  );
}